/* Wonderwick candlelight scavenger hunt — reveal engine + gated state machine.
 *
 * Desktop + Candlelight only. Rides the same pointer the candle cursor uses and
 * masks "invisible ink" (.wf-ink) into view only inside the flame's glow. A
 * linear, localStorage-gated hunt: the home riddle (step 1) unlocks the About
 * wyvern (step 2). Nothing here touches the candle itself — it only reads the
 * candle root's geometry so the reveal and the visible light pool line up.
 *
 * Elements opt in with:
 *   class="wf-ink"  data-wf-hunt="riddle" | "reward"
 * The reward (wyvern) also carries data-wf-pop="<id>" pointing at its popover.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'wf-hunt-step';
  var RIDDLE_KEY = 'wf-hunt-riddle';         // the developed riddle's HTML, carried to the About page
  var RECALL_CLOSED_KEY = 'wf-hunt-recall-x'; // legacy (dismissal was persisted for a day); only ever cleared now
  var REVEAL_R = 360;      // mask reveal radius (px) — the lit pool that develops the ink
  var RIDDLE_DWELL = 900;  // ms the glow must dwell on the riddle before it "develops" (step 1)
  var REWARD_DWELL = 350;  // ms the glow must dwell on the wyvern before it latches visible + clickable
  var LERP = 0.35;         // pointer easing — matches the candle so reveal tracks the visible pool

  // Desktop + motion-ok only. Matches the candle cursor's own gate.
  var mq = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  if (!mq.matches) return;

  // ---- state (localStorage, defensive: private windows throw) ----------------
  function getStep() {
    try { return parseInt(localStorage.getItem(STORAGE_KEY), 10) || 0; }
    catch (e) { return wfMemStep || 0; }
  }
  var wfMemStep = 0; // in-memory fallback when storage is blocked
  function setStep(n) {
    if (n <= getStep()) return;
    wfMemStep = n;
    try { localStorage.setItem(STORAGE_KEY, String(n)); } catch (e) {}
    if (n === 1) stashRiddle();
    armAll();
    syncRecall();
    try { document.dispatchEvent(new CustomEvent('wf:hunt', { detail: { step: n } })); } catch (e) {}
  }

  // ---- candle geometry (read once; fall back to the candle's own defaults) ----
  var candle = document.querySelector('[data-wf-vibe-effect="candle"]');
  function cnum(attr, d) {
    if (!candle) return d;
    var v = parseFloat(candle.getAttribute(attr));
    return isNaN(v) ? d : v;
  }
  var SHIFT_X = cnum('data-shift-x', 30);
  var RADIUS = cnum('data-radius', 320);
  var LIFT = RADIUS * (cnum('data-offset', 30) / 100); // light pool sits this far above the pointer

  // ---- elements --------------------------------------------------------------
  var inks = [];
  function collect() {
    inks = Array.prototype.slice.call(document.querySelectorAll('.wf-ink[data-wf-hunt]')).map(function (el) {
      return { el: el, role: el.getAttribute('data-wf-hunt'), dwell: 0, found: el.classList.contains('is-found') };
    });
  }

  function armAll() {
    var step = getStep();
    inks.forEach(function (it) {
      var armed = it.role === 'riddle' ? true : step >= 1; // reward gated behind the riddle
      it.el.classList.toggle('is-armed', armed);
      if (it.role === 'reward') {
        // keyboard: only a found, armed wyvern is focusable
        if (armed && it.found) it.el.setAttribute('tabindex', '0');
        else it.el.setAttribute('tabindex', '-1');
      }
    });
  }

  // ---- riddle recall: carry the developed riddle to the wyvern's page ---------
  // Once the home riddle has developed (step 1) its text is stashed, and on any
  // page that hosts the reward (About) a small fixed parchment note repeats it,
  // so the reader doesn't have to bounce back to the home page to re-read the
  // clue. Closable (sticks), and gone once the hunt is complete (step 2).
  var wfMemRiddle = null;
  function stashRiddle() {
    var el = document.querySelector('.wf-hunt-riddle[data-wf-hunt="riddle"]');
    if (!el) return;
    var fontCls = Array.prototype.filter.call(el.classList, function (c) { return c.indexOf('bc-') === 0; }).join(' ');
    var data = { html: el.innerHTML.trim(), cls: fontCls };
    wfMemRiddle = data;
    try { localStorage.setItem(RIDDLE_KEY, JSON.stringify(data)); } catch (e) {}
  }
  function getRiddle() {
    try {
      var raw = localStorage.getItem(RIDDLE_KEY);
      if (raw) { var d = JSON.parse(raw); if (d && d.html) return d; }
    } catch (e) {}
    return wfMemRiddle;
  }
  // Closing the note is per page view only (in memory): it comes back on the
  // next visit to the page. Julia: "shouldn't permanently go away when you x
  // out of it". RECALL_CLOSED_KEY is no longer written; reset still clears it.
  var wfMemClosed = false;
  function recallClosed() { return wfMemClosed; }
  function closeRecall() {
    wfMemClosed = true;
    syncRecall();
  }
  // Fallback: step 1 was reached but the riddle text was never stashed (the
  // reader's step predates the stash, or storage was cleared). Pull it from the
  // home page once and stash it, then rebuild the note.
  var fetchedRiddle = false;
  function fetchRiddle() {
    if (fetchedRiddle || !window.fetch || !window.DOMParser) return;
    fetchedRiddle = true;
    fetch('/', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('.wf-hunt-riddle[data-wf-hunt="riddle"]');
      if (!el) return;
      var fontCls = Array.prototype.filter.call(el.classList, function (c) { return c.indexOf('bc-') === 0; }).join(' ');
      wfMemRiddle = { html: el.innerHTML.trim(), cls: fontCls };
      try { localStorage.setItem(RIDDLE_KEY, JSON.stringify(wfMemRiddle)); } catch (e) {}
      syncRecall();
    }).catch(function () {});
  }
  // Drop the blank "spacer" paragraphs the richtext editor uses to fake
  // paragraph gaps (they hold only &nbsp; / zero-width marks); CSS gives the
  // real paragraphs a half-line gap instead.
  function stripSpacers(root) {
    Array.prototype.slice.call(root.querySelectorAll('p')).forEach(function (p) {
      if (!p.querySelector('img') && !p.textContent.replace(/[\s\u00a0\u200e\u200f\u200b\ufeff]/g, '')) p.remove();
    });
  }
  function syncRecall() {
    var existing = document.querySelector('.wf-hunt-recall');
    var step = getStep();
    var hostsReward = !!document.querySelector('.wf-hunt-wyvern[data-wf-hunt="reward"]');
    var show = hostsReward && step >= 1 && step < 2 && !recallClosed();
    var data = show ? getRiddle() : null;
    if (show && !data) fetchRiddle();
    if (!show || !data) { if (existing) existing.remove(); return; }
    if (existing) return;
    var note = document.createElement('aside');
    note.className = 'wf-hunt-recall';
    note.setAttribute('aria-label', 'Your clue');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'wf-hunt-recall__close';
    close.setAttribute('aria-label', 'Close clue');
    close.innerHTML = '&times;';
    var body = document.createElement('div');
    body.className = 'wf-hunt-recall__text' + (data.cls ? ' ' + data.cls : '');
    body.innerHTML = data.html;
    stripSpacers(body);
    note.appendChild(close);
    note.appendChild(body);
    document.body.appendChild(note);
  }

  // ---- pointer ---------------------------------------------------------------
  var seed = window.__wfLastPointer || {};
  var tx = typeof seed.x === 'number' ? seed.x : -2000;
  var ty = typeof seed.y === 'number' ? seed.y : -2000;
  var x = tx, y = ty, last = 0, running = false;

  function active() {
    return document.documentElement.getAttribute('data-wf-vibe') === 'candle';
  }

  document.addEventListener('mousemove', function (e) {
    tx = e.clientX; ty = e.clientY;
    if (active()) start();
  }, { passive: true });

  function markFound(it) {
    it.found = true;
    it.el.classList.add('is-found'); // CSS drops the mask -> fully legible, and latches it on screen
    if (it.role === 'reward') it.el.setAttribute('tabindex', '0');
  }

  function pointIn(rect, px, py, pad) {
    pad = pad || 0;
    return px >= rect.left - pad && px <= rect.right + pad &&
           py >= rect.top - pad && py <= rect.bottom + pad;
  }

  function frame(t) {
    if (!active()) { running = false; return; }
    var dt = last ? Math.min(t - last, 64) : 16;
    last = t;

    x += (tx - x) * LERP;
    y += (ty - y) * LERP;
    var lx = x + SHIFT_X;      // light pool center = candle flame position
    var ly = y - LIFT;

    for (var i = 0; i < inks.length; i++) {
      var it = inks[i];
      if (!it.el.classList.contains('is-armed')) continue;
      var r = it.el.getBoundingClientRect();
      if (r.width === 0 || r.bottom < -400 || r.top > window.innerHeight + 400) continue;

      // Move the reveal mask to the glow, in the element's own coordinate space.
      // The reward is scaleX(-1) mirrored, so its local X axis is flipped versus
      // the screen — mirror the glow's X (r.right - lx) or the reveal comes in
      // from the wrong side. Y is never flipped.
      var mx = it.role === 'reward' ? (r.right - lx) : (lx - r.left);
      it.el.style.setProperty('--wf-ink-mx', mx + 'px');
      it.el.style.setProperty('--wf-ink-my', (ly - r.top) + 'px');
      it.el.style.setProperty('--wf-ink-r', REVEAL_R + 'px');

      var glowOver = pointIn(r, lx, ly, 24); // the lit pool (not the raw cursor) sits over it

      if (it.role === 'reward') {
        // Reward never latches: like the riddle it shows only while lit and
        // vanishes on mouse-out. The glow pool tracks it consistently (no hard
        // full-reveal snap); a cursor over it keeps it lit so the click lands.
        var cursorOver = pointIn(r, tx, ty, 0);
        it.el.classList.toggle('is-lit', glowOver || cursorOver);
        continue;
      }

      // Riddle: dwell while the glow pool sits over it, then unlock the reward.
      // It never latches — it's visible only while the glow is over it.
      if (glowOver) {
        it.dwell += dt;
        if (it.dwell >= RIDDLE_DWELL) setStep(1); // unlock the wyvern; idempotent
      } else {
        it.dwell = Math.max(0, it.dwell - dt * 0.6); // bleed off so a passing brush doesn't accumulate
      }
    }
    requestAnimationFrame(frame);
  }

  function start() {
    if (running) return;
    running = true;
    last = 0;
    requestAnimationFrame(frame);
  }

  // ---- reward: click the found wyvern -> popover + claim ----------------------
  function openPop(wyvern) {
    var id = wyvern.getAttribute('data-wf-pop');
    var pop = id && document.getElementById(id);
    if (!pop) return;
    pop.classList.add('is-open');
    pop.removeAttribute('hidden');
    setStep(2);
    var closer = pop.querySelector('.wf-hunt-pop__close');
    if (closer) closer.focus();
  }
  function closePop(pop) {
    pop.classList.remove('is-open');
    pop.setAttribute('hidden', '');
  }

  document.addEventListener('click', function (e) {
    var wy = e.target.closest ? e.target.closest('.wf-hunt-wyvern.is-lit.is-armed') : null;
    if (wy) { e.preventDefault(); openPop(wy); return; }

    var copy = e.target.closest ? e.target.closest('.wf-hunt-pop__copy') : null;
    if (copy) {
      var code = copy.getAttribute('data-code') || '';
      var done = function () {
        copy.classList.add('is-copied');
        var label = copy.querySelector('.wf-hunt-pop__copy-label') || copy;
        var prev = label.textContent;
        label.textContent = 'Copied!';
        setTimeout(function () { copy.classList.remove('is-copied'); label.textContent = prev; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(function () { legacyCopy(code, done); });
      } else { legacyCopy(code, done); }
      return;
    }

    var recallX = e.target.closest ? e.target.closest('.wf-hunt-recall__close') : null;
    if (recallX) { closeRecall(); return; }

    var closeBtn = e.target.closest ? e.target.closest('.wf-hunt-pop__close') : null;
    if (closeBtn) { var p = closeBtn.closest('.wf-hunt-pop'); if (p) closePop(p); return; }

    // outside click closes an open popover
    var open = document.querySelector('.wf-hunt-pop.is-open');
    if (open && !e.target.closest('.wf-hunt-pop') && !e.target.closest('.wf-hunt-wyvern')) closePop(open);
  });

  function legacyCopy(text, done) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'absolute'; ta.style.left = '-9999px';
      document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      done();
    } catch (e) {}
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('.wf-hunt-pop.is-open');
      if (open) closePop(open);
    }
    // Enter/Space on a focused found wyvern
    if ((e.key === 'Enter' || e.key === ' ')) {
      var wy = document.activeElement && document.activeElement.classList &&
               document.activeElement.classList.contains('wf-hunt-wyvern') &&
               document.activeElement.classList.contains('is-lit') ? document.activeElement : null;
      if (wy) { e.preventDefault(); openPop(wy); }
    }
  });

  // ---- lifecycle -------------------------------------------------------------
  document.addEventListener('wf:vibe', function (e) {
    if (e.detail && e.detail.mode === 'candle') { x = tx; y = ty; start(); }
  });

  // Testing switch: ?wf-hunt=reset | 0 | 1 | 2 forces the hunt state for this
  // browser (reset also clears the stashed riddle + the dismissed recall note).
  (function () {
    var m = /[?&]wf-hunt=(reset|[012])\b/.exec(window.location.search);
    if (!m) return;
    try {
      if (m[1] === 'reset' || m[1] === '0') {
        [STORAGE_KEY, RIDDLE_KEY, RECALL_CLOSED_KEY].forEach(function (k) { localStorage.removeItem(k); });
        wfMemStep = 0; wfMemRiddle = null; wfMemClosed = false;
      } else {
        localStorage.setItem(STORAGE_KEY, m[1]);
        localStorage.removeItem(RECALL_CLOSED_KEY);
        wfMemStep = parseInt(m[1], 10); wfMemClosed = false;
      }
    } catch (e) {}
  })();

  function init() {
    collect();
    armAll();
    if (getStep() >= 1) stashRiddle(); // revisiting home after step 1: refresh the stashed copy
    syncRecall();
    if (active()) start();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: sections re-render on edit — re-collect so new instances work.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { collect(); armAll(); syncRecall(); if (active()) start(); });
  }
})();
